import { FC } from "react";
import { FormattedMessage } from "react-intl";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  Typography,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import settings from "settings";

import messages from "./messages";

import useStyles from "./PlanOrderCard.styles";

interface PlanOrderCardProps {
  customerId: string;
  onOpenInvoiceHistory: (params: { customer_id: string }) => void;
}

export const PlanOrderCard: FC<PlanOrderCardProps> = ({
  customerId,
  onOpenInvoiceHistory,
}) => {
  const classes = useStyles();

  const onClick = () => {
    window.open(settings.MMS_PRICING_URL());
  };

  return (
    <Card elevation={1} className={classes.root}>
      <Box className={classes.icon}>
        <AddIcon />
      </Box>
      <CardActionArea className={classes.actionArea}>
        <CardHeader title={<FormattedMessage {...messages.bookNewTitle} />} />

        <CardContent className={classes.content}>
          <Typography
            variant="body1"
            className={classes.details}
            onClick={onClick}
          >
            <FormattedMessage {...messages.bookCallToAction} />
          </Typography>

          {customerId && (
            <Button
              variant="contained"
              color="primary"
              type="submit"
              onClick={() =>
                onOpenInvoiceHistory({
                  customer_id: customerId,
                })
              }
            >
              <FormattedMessage {...messages.billingHistory} />
            </Button>
          )}
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
